

import { Averages } from "../AveragesComputer";

import { DrawingService } from "../../Services/DrawingService";

import { BarData, BarPrice, Coordinate, LineData, Time, UTCTimestamp } from "lightweight-charts";
import { IndicatorDrawers } from "../IndicatorDrawers";
import { CountsData } from "src/app/Services/dg-hub-client.service";
import { ISeriesApi } from "../lcharts/src/api/iseries-api";
import { LineStyle, LineType, LineWidth } from "../lcharts/src/api/create-chart";
import { ExtensionType } from "../lcharts/src/model/series-options";

export class NotificationDisplayer extends IndicatorDrawers {
  
  constructor(private _drawingService:DrawingService) { 
    super(_drawingService);
  };

  public range: number[] = [];

  public drawAction(canShow: boolean) 
  {
    if(!this._drawingService.settingsService.showChartEvent)
    {
      jQuery(".notifItem").remove();;
      return;
    }
    jQuery(".notifItem").remove();
   // var data = this._drawingService.signalService.eventsData;
    //  this._drawingService.signalService.signalSeriesIndexMap.set
    let rList = [...this._drawingService.signalService.signalSeriesIndexMap.values()];

    let newVisibleTimeRange = {
      from: this._drawingService
        .chart.chart.timeScale()
        .getVisibleRange().from,
      to: this._drawingService
        .chart.chart.timeScale()
        .getVisibleRange().to,
    };

    rList.forEach(element => {
      var data = this.signalSeriesIndexMap.get(element.serieIndex);
      if(data)
      {
        // if(((data.tradeInfo.ssboe as UTCTimestamp) as Time)>newVisibleTimeRange.from&&((data.tradeInfo.ssboe as UTCTimestamp) as Time)<newVisibleTimeRange.to)
        // {
        //   console.log("out of range");
        // }
       //  //console.log(element.serieIndex);
     //  var data = this.signalSeriesIndexMap.get()
     if(((data.tradeInfo.ssboe as UTCTimestamp) as Time)>newVisibleTimeRange.from&&((data.tradeInfo.ssboe as UTCTimestamp) as Time)<newVisibleTimeRange.to){
            var color = (data.symbol.includes(" C")?'#00ff00':'#ff0000');
            var colorClass = (data.symbol.includes(" C")?'in-green':'in-red');

            var y = this._drawingService.chart.chart.getChartModel().mainPriceScale().priceToCoordinate(data.strike, 0);
            var y1 = this._drawingService.chart.chart.getChartModel().mainPriceScale().priceToCoordinate(data.lastPrice, 0);
            var locClass="";//((y1-y)>0)?"loc-down":"loc-up";

            var yt = y;
            var yt1 = y1

            var c = 23;
            if(yt>yt1)
            {
                yt1=(Number(yt1)-c) as Coordinate;
            }
            else
            {
              yt=(Number(yt)-c) as Coordinate;
            }

            jQuery("#chartWrapper").append(`<div att-id="${element.serieIndex}" style="top: ${yt}px; left: ${element.startX}px;"  class='notifItem'>
            <div style="color:${color}!important" class='strike-inline ${colorClass}  ${locClass}'>
               ${data.strike}
            </div></div>`);

            var pointsLoc = (y + y1) / 2;
            jQuery("#chartWrapper").append(`<div att-id="${element.serieIndex}_end" style="top: ${pointsLoc}px; left: ${element.startX}px;"  class='notifItem notifItemPoints'>
            <div class="points">${data.tradeInfoPricePointsFixed}</div>
            </div>`);
            

            jQuery("#chartWrapper").append(`<div att-id="${element.serieIndex}_end" style="top: ${yt1}px; left: ${element.startX}px;"  class='notifItem notifItemEnd'>
            <div class="time-inline  ${colorClass} ${locClass}" style="color:${data.timeColor}!important">${data.formattedTimeS}</div>
            </div>`);

            jQuery("#chartWrapper").append(`<div id="${element.serieIndex}_svg" att-id="${element.serieIndex}_svg" style="top: ${y}px; left: ${element.startX}px;background-color:red;width:20px;height:10px;position:absolute;"  class='notifItem svg'></div>`);
             var arrow = this.arrowTemplate (`${element.serieIndex}_svg_content`,0,0,0,y1-y, color);
            jQuery(`#${element.serieIndex}_svg`).append(arrow);
        }
      }
       
    });
  }

  public arrowTemplate (id, x, y, x1, y1, color) {
    //return;
    if((y-y1)>0)
    {
      var arrowBase = `<svg style='overflow:visible; position:absolute;' class='notifItem' id="${id}">
          <line x1="${x}" y1="${y}" x2="${x}" y2="${y1}" stroke="${color}" stroke-width="2"/>

  
      </svg>`;
    }
    else
    {
      var arrowBase = `<svg style='overflow:visible; position:absolute;' class='notifItem' id="${id}">
      <line x1="${x}" y1="${y}" x2="${x}" y2="${y1}" stroke="${color}" stroke-width="2"/>
    
  </svg>`;
    }

    return arrowBase;
}


//   public arrowTemplate (id, x, y, x1, y1, color) {
//     //return;
//     if((y-y1)>0)
//     {
//       var arrowBase = `<svg style='overflow:visible; position:absolute;' class='notifItem' id="${id}">
//           <line x1="${x}" y1="${y}" x2="${x}" y2="${y1}" stroke="${color}" stroke-width="2"/>
//           <polygon fill="${color}" points="${x},${y + 3.5}, ${x - 5},${y}, ${x + 5},${y}"/>
//           <polygon fill="${color}" points="${x},${y1 - 3.5}, ${x - 5},${y1}, ${x + 5},${y1}"/>
  
//       </svg>`;
//     }
//     else
//     {
//       var arrowBase = `<svg style='overflow:visible; position:absolute;' class='notifItem' id="${id}">
//       <line x1="${x}" y1="${y}" x2="${x}" y2="${y1}" stroke="${color}" stroke-width="2"/>
//       <polygon fill="${color}" points="${x},${y1 + 3.5}, ${x - 5},${y1}, ${x + 5},${y1}"/>
//       <polygon fill="${color}" points="${x},${y - 3.5}, ${x - 5},${y}, ${x + 5},${y}"/>
//   </svg>`;
//     }

//     return arrowBase;
// }

  public series:ISeriesApi<"Bar">[]=[]
  public fullDraw()
  {

    jQuery(".notifItem").remove();
      this.signalSeriesIndexMap.clear();
      this.baseSeries.forEach((e)=>{
        if(e)
        {
          this._drawingService.chart.chart.removeSeries(e);
        }
        
      });
      this.baseSeries = [];
      
    if(!this._drawingService.settingsService.showChartEvent)
    {
      
      return;
    }

    if( this._drawingService.signalService.currentDataMode==1){
      var eventsTommorowDayData = this._drawingService.signalService.eventsTomorrowDayData;
      eventsTommorowDayData.forEach(element => {
        this.drawSingleSignal(element)
      });
    }
    else{
    var data = this._drawingService.signalService.eventsData;
    data.forEach(element => {
      this.drawSingleSignal(element)

     // this._drawingService.chart.chart.addLineSeries()
    });
  }

   
  }


  public reset()
  {
    jQuery(".notifItem").remove();
    this.signalSeriesIndexMap.clear();
    this.baseSeries.forEach((e)=>{
      if(e)
      {
        this._drawingService.chart.chart.removeSeries(e);
      }
      
    });
    this.baseSeries = [];
    return;
  }

  public limit:number = 20000;
 // public limit:number = 2000;
  public drawSingleSignal(element:CountsData)
  {
    
    if(element.costOfTrade>this.limit){
    var startBase: BarData[] = [];
    
          startBase.push( {time: element.tradeInfo.ssboe,
                open: element.strike,
                high: element.strike,
                low: element.strike,
                close: element.strike,
                })


                var lineBase: LineData[] = [];
    
          startBase.push( {time: element.tradeInfo.ssboe,
                open: element.strike,
                high: element.strike,
                low: element.strike,
                close: element.strike,
                })
  
                lineBase.push({ time: (Number(element.tradeInfo.ssboe)) as UTCTimestamp, value: element.strike });
                lineBase.push({ time: (Number(element.tradeInfo.ssboe)) as UTCTimestamp, value: element.strike });

                var color = "#000000"
                if(element.symbol.includes(" P"))
                {
                    color = "#ff0000"
                }
                else
                {
                  color = "#00ff00"
                }
        var baseLine = this._drawingService.chart.chart.addLineSeries({
          color: color,
          lineStyle: LineStyle.Solid,
          lineWidth: 1,
          crosshairMarkerVisible: false,
          crosshairMarkerRadius: 6,
          lineType: LineType.Simple,
          priceLineVisible: true,//isExtended,
          lastValueVisible: false,
          priceLineColor: color,
          priceLineStyle: LineStyle.Dashed,
          priceLineWidth: (1) as LineWidth,
          priceLineExtended:true,//isExtended,
          priceLineExtendedType: ExtensionType.None//(isExtended)?ExtensionType.Right:ExtensionType.None
      });

      baseLine.setData(lineBase);
      let baseIndex =  baseLine.getSerieIndex();
      this.signalSeriesIndexMap.set(baseIndex,element);
      this.baseSeries.push(baseLine);
      //this._drawingService.chart.chart.removeSeries
    }
  }

  public baseSeries:ISeriesApi<"Line">[]=[]
















  public signalSeriesIndexMap: Map<number, CountsData> = new Map<number, CountsData>();
  public addBar(data:CountsData)
  {
   
  //   let startBase: BarData[] = [{ time: data.dateTime,
  //      open: data.strike,
  //      high: data.strike+1,
  //      low: data.strike-1,
  //      close: data.strike-1,
  //     }];

  //  var baseLine = this._drawingService.chart.chart.addBarSeries({
  //     thinBars: true,
  //     upColor: "#00ff00",
  //     downColor: "#ff00ff",
  //     openVisible: false,
  //     priceLineVisible: false,
  //     lastValueVisible: false,
  // });

  //   baseLine.setData(startBase);
  //   var baseIndex =  baseLine.getSerieIndex();

  }






}
